





























import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import AuthService from "@/services/AuthService";
import { ifValid, processError } from "@/utils/ComponentUtils";
import LandingInput from "@/components/landing/common/LandingInput.vue";
import Application from "@/state/Application";
import Notifications from "@/state/Notifications";
import ErrorLocalePathUtils from "@/utils/ErrorLocalePathUtils";

const Auth = namespace("Auth");
const AppModule = namespace("App");

@Component({
  components: { LandingInput }
})
export default class RestorePassword extends Vue {
  private emailForPasswordReset = "";

  handleRestorePassword(): void {
    ifValid(this, () => {
      Application.startLoading();
      AuthService.requestPasswordResetLink(this.emailForPasswordReset).then(
        response => {
          Application.stopLoading();
          Notifications.success(this.$t('auth.register_link_sent') as string);
          this.goLogin();
        },
        error => {
          Application.stopLoading();
          processError(error, this);
        }
      );
    });
  }

  goLogin(): void {
    this.$emit('toggleMode', 'Login');
  }
}
